import { extendTheme } from "@chakra-ui/react";

// Brand of chytanka.com / the approved admin-web cabinet design:
// orange #FF7C49 + charcoal #313131, pill buttons.
export const publisherPanelTheme = extendTheme({
  colors: {
    brand: {
      orange: "#FF7C49",
      charcoal: "#313131",
    },
  },
  fonts: {
    heading: `'HK Grotesk', 'Commissioner', system-ui, sans-serif`,
    body: `'HK Grotesk', 'Commissioner', system-ui, sans-serif`,
  },
  styles: {
    global: {
      body: {
        bg: "#F7F7F7",
        color: "brand.charcoal",
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: "full",
        fontWeight: 600,
      },
      variants: {
        solid: {
          bg: "brand.orange",
          color: "white",
          _hover: { bg: "#FF6A30", _disabled: { bg: "brand.orange" } },
          _active: { bg: "#F25F26" },
        },
        outline: {
          borderColor: "brand.charcoal",
          color: "brand.charcoal",
        },
      },
    },
  },
});
